import { Menu } from "./Menu.js";


/**
 * Class to implement the menu manager
 * as a singleton, which can be instantiated by
 * any other extension as a dependency
 */
export class MenuManager
{
    private static manager: MenuManager;
    private instances: Menu[] = [];

    /**
     * The private constructor
     * prevents direct instantiation
     */
    private constructor()
    {
        this.menus.forEach(menu => {
            this.instances.push(new Menu(menu));
        });
    }

    /**
     * Method to instantiate all
     * menus on the current page
     *
     * @param {boolean} [reset=false]
     * @returns {MenuManager}
     */
    public static use(reset: boolean = false): MenuManager
    {
        if (!MenuManager.manager || reset) {
            MenuManager.manager = new MenuManager();
        }
        return MenuManager.manager;
    }

    /**
     * Selects the menus
     *
     * @returns {NodeListOf<HTMLElement>}
     */
    protected get menus(): NodeListOf<HTMLElement>
    {
        return document.querySelectorAll(`body > header > section > div > nav`);
    }

    /**
     * Returns the number of instantiated menus
     *
     * @returns {number}
     */
    public get length(): number
    {
        return this.instances.length;
    }
}
